import {isNotNilOrEmpty} from 'ramda-adjunct';

import {ScopeValues} from '@dms/api/shared';

import {Nullish} from 'shared/web';

import {PermissionsKeys} from '../permissions';

type ParamsWithScopes = {
  scopes: ScopeValues | Nullish;
  permissionKeys: PermissionsKeys[];
};

export const areParamsWithScope = (params: unknown): params is ParamsWithScopes =>
  isNotNilOrEmpty((params as ParamsWithScopes)?.scopes);
